import React from 'react'

export default function BackIcon () {
  const goBack = () => {
    history.back()
  }
  return (
    <button
      className="btn btn-link p-0 me-2"
      onClick={goBack}
      style={{ fontSize: '1.5rem', color: '#000' }}
    >
      <i className="ri-arrow-left-line"></i>
    </button>
  )
}
